export class StakeholdersModel {
  id: number;
  nome: string;
  empresa: string;
  funcao_pt: string;
  funcao_en: string;
  funcao_es: string;
}




// WEBPACK FOOTER //
// ./src/app/laudos-tecnicos-stakeholders/stakeholders.model.ts